module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "rouble"
  }, [_vm._v("Р")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6389ac7e","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ext/currency/Rouble.vue
// module id = 2cee9f95e2fbc1222a9a
// module chunks = 89